<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <h1>Users</h1>

        <form
          class="searchForm"
          @submit.prevent="onSearchSubmit"
        >
          <md-field>
            <label>Search by email</label>
            <md-input
              v-model="search.email"
              :disabled="isLoading"
            />
          </md-field>

          <md-field>
            <label>Search by ID</label>
            <md-input
              v-model="search.id"
              :disabled="isLoading"
            />
          </md-field>

          <md-button
            class="md-primary searchButton"
            type="submit"
          >
            Search
          </md-button>
        </form>

        <md-progress-bar
          v-if="isLoading"
          md-mode="query"
        />
        <v-client-table
          v-else
          :data="accounts"
          :columns="table.columns"
          :options="table.options"
        >
          <template #email="props">
            <a
              :href="`/user/${props.row.id}`"
              target="_blank"
              class="email"
            >{{ props.row.email.email }}</a>
          </template>
        </v-client-table>

        <md-button
          v-if="!isLoading"
          class="loadMoreButton"
          @click="loadMoreUsers"
        >
          Load more
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
    const emailParamKey = "email";
    const idParamKey = "id";

    export default {
        name: "UsersPage",
        data() {
            return {
              isLoading: true,
              accounts: [],
              nextPageToken: "",

              search: {
                email: "",
                id: ""
              },

              table: {
                columns: [
                  "email", "organization", "type", "state"
                ],
                options: {
                  perPage: 200,
                }
              }
            };
        },
        mounted() {
          this.fetchAccounts();
        },
        methods: {
          fetchAccounts(emailQuery, idQuery, pageToken = "") {
            const params = new URLSearchParams(window.location.search);
            emailQuery = emailQuery || params.get(emailParamKey) || "";
            idQuery = idQuery || params.get(idParamKey) || "";

            let endpointURL = "/v1/admin/account/list-accounts?page_size=20&filters.id";
            if (idQuery) {
              endpointURL = `/v1/admin/account/list-accounts?page_size=20&filters.id=${encodeURIComponent(idQuery)}`;
              params.set(idParamKey, idQuery);
              this.search.id = idQuery;
            } else if (emailQuery) {
              endpointURL = `/v1/admin/account/list-accounts?page_size=20&filters.email=${encodeURIComponent(emailQuery)}`;
              params.set(emailParamKey, emailQuery);
              this.search.email = emailQuery;
            }

            if (pageToken) {
              endpointURL += `&page_token=${pageToken}`;
            } else {
              this.isLoading = true;
            }

            window.history.replaceState(null, "", window.location.pathname + "?" + params.toString());
            this.$http.get(endpointURL)
              .then(res => {
                if (pageToken) {
                  this.accounts = [...this.accounts, ...res.data.accounts];
                } else {
                  this.accounts = res.data.accounts;
                }
                this.nextPageToken = res.data.next_page_token;
              })
              .then(() => { this.isLoading = false; });
          },
          onSearchSubmit () {
            this.fetchAccounts(this.search.email, this.search.id);
          },
          loadMoreUsers() {
            this.fetchAccounts(this.search.email, this.search.id, this.nextPageToken);
          }
        }
    };
</script>

<style lang="scss">
  .searchForm {
    display: flex;
    column-gap: 16px;

    .searchButton {
      height: 40px;
    }
  }

  .email {
    display: block;
    text-align: left;
    padding: 8px;
  }

  .VuePagination {
    justify-content: center;
  }

  .loadMoreButton {
    display: block;
    margin: 12px auto;
  }
</style>
